import React from 'react';
import StatusBadge from './StatusBadge';
import { fmt, fmtCurrency } from '../utils/helpers';

export default function RequestTable({ requests, onRowClick, selectedId }) {
  if (!requests || requests.length === 0)
    return <div style={{ padding: '32px 0', textAlign: 'center', color: '#888', fontSize: 14 }}>No requests found.</div>;
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead>
          <tr style={{ background: '#f5f4f0' }}>
            {['Request ID','Beneficiary','Project','Type','Amount','Date','Status'].map(h => (
              <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontWeight: 600, color: '#444', borderBottom: '1px solid #e8e6de', whiteSpace: 'nowrap' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {requests.map(r => (
            <tr key={r.id} onClick={() => onRowClick && onRowClick(r)}
              style={{ cursor: onRowClick ? 'pointer' : 'default', background: selectedId === r.id ? '#EEEDFE' : 'transparent' }}
              onMouseEnter={e => { if (selectedId !== r.id) e.currentTarget.style.background = '#faf9f7'; }}
              onMouseLeave={e => { if (selectedId !== r.id) e.currentTarget.style.background = 'transparent'; }}>
              <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0eeea', fontFamily: 'DM Mono, monospace', fontSize: 12, color: '#534AB7' }}>{r.id}</td>
              <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0eeea', fontWeight: 500 }}>{r.beneficiaryName}</td>
              <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0eeea', color: '#555', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.projectName}</td>
              <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0eeea', color: '#555' }}>{r.paymentType}</td>
              <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0eeea', fontWeight: 500, whiteSpace: 'nowrap' }}>{fmtCurrency(r.amount, r.currency)}</td>
              <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0eeea', color: '#888', whiteSpace: 'nowrap' }}>{fmt(r.requestDate)}</td>
              <td style={{ padding: '10px 12px', borderBottom: '1px solid #f0eeea' }}><StatusBadge status={r.status} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
